module.exports = __webpack_public_path__ + "images/help/video-todos@2x-cd0a78ca8d8334f4d8155c997aee833e.png";